<template>
    <div class="reserva-ok">
        <p v-if="loading">{{ translate('reservaCompletando') }}</p>
        <p v-else-if="error">{{ error }}</p>
        <p v-else>{{ translate('reservaListo') }}</p>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import dialogs from '@/services/dialogs';

const STORAGE_KEY_PAYLOAD = 'reserva_trip_payload';
const STORAGE_KEY_PAGO_ID = 'reserva_pago_id';

export default {
    name: 'ReservaOk',
    data () {
        return {
            loading: true,
            error: null
        };
    },
    computed: {
        ...mapGetters({
            settings: 'company/config'
        })
    },
    mounted () {
        if (!this.settings.modulo_reserva_de_viajes) {
            this.$router.replace({ name: 'home' });
            return;
        }
        const pagoIdSession = sessionStorage.getItem(STORAGE_KEY_PAGO_ID);
        const payloadStrSession = sessionStorage.getItem(STORAGE_KEY_PAYLOAD);

        const pagoIdLocal = localStorage.getItem(STORAGE_KEY_PAGO_ID);
        const payloadStrLocal = localStorage.getItem(STORAGE_KEY_PAYLOAD);

        // Prefer sessionStorage, fallback to localStorage.
        const pagoId = pagoIdSession || pagoIdLocal;
        const payloadStr = payloadStrSession || payloadStrLocal;

        sessionStorage.removeItem(STORAGE_KEY_PAGO_ID);
        sessionStorage.removeItem(STORAGE_KEY_PAYLOAD);
        localStorage.removeItem(STORAGE_KEY_PAGO_ID);
        localStorage.removeItem(STORAGE_KEY_PAYLOAD);
        const pagoIdQuery = this.$route && this.$route.query ? this.$route.query.pago_reserva_id : null;

        if (!pagoId || !payloadStr) {
            // New flow: passenger inicia pago desde "Mis Reservas" y no se guarda payload en storage.
            // El viaje ya existe; mostramos confirmación y redireccionamos.
            if (pagoIdQuery) {
                this.loading = false;
                this.error = null;
                dialogs.message(this.translate('reservaConfirmada'), { duration: 5, estado: 'success' });
                setTimeout(() => this.$router.replace({ name: 'reservas' }), 1000);
                return;
            }
            this.loading = false;
            this.error = this.translate('reservaSinDatos');
            setTimeout(() => this.$router.replace({ name: 'home' }), 2000);
            return;
        }
        let payload;
        try {
            payload = JSON.parse(payloadStr);
        } catch (e) {
            this.loading = false;
            this.error = this.translate('reservaSinDatos');
            setTimeout(() => this.$router.replace({ name: 'home' }), 2000);
            return;
        }
        payload.reserva_pago_id = parseInt(pagoId, 10);
        this.createTrip(payload).then((tripData) => {
            this.loading = false;
            dialogs.message(this.translate('reservaConfirmada'), { duration: 5, estado: 'success' });
            this.$router.replace({ name: 'home' });
        }).catch((err) => {
            this.loading = false;
            this.error = (err && err.data && (err.data.reserva_pago_id || err.data.message)) || this.translate('problemaInesperado');
            if (err && err.data && err.data.reserva_pago_id) {
                this.error = Array.isArray(err.data.reserva_pago_id) ? err.data.reserva_pago_id[0] : err.data.reserva_pago_id;
                // If bypass already created the trip, reserva_pago_id may be "already used".
                // In that case, just go to the reservas list.
                setTimeout(() => {
                    this.$router.replace({ name: 'reservas' });
                }, 2000);
            }
        });
    },
    methods: {
        ...mapActions({
            createTrip: 'passenger/createTrip'
        }),
        translate (key) {
            return this.$lang ? this.$lang(key) : key;
        }
    }
};
</script>

<style scoped>
.reserva-ok {
    padding: 2rem;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/views/ReservaOk.vue